import { ApplicantPetV2Dto, ApplicationV2Dto } from '@inosio/payments-sdk';
import { Box } from '@mui/system';
import ApplicationDetailsApplicantEntityData, { ApplicantEntityDataTableField } from './ApplicationDetailsApplicantEntityData';
import { Typography, Divider, Accordion, AccordionSummary, Grid, AccordionDetails } from '@mui/material';
import { handleBuildCustomQuestionDataTable } from './helpers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export interface ApplicationDetailsAnimalsProps {
  application: ApplicationV2Dto;
}
export default function ApplicationDetailsAnimals(props: ApplicationDetailsAnimalsProps) {
  const allApplicantsOnThisApplication = [...(props.application.CoApplicants || []), props.application.PrimaryApplicant];

  const allAnimalsOnThisApplication = allApplicantsOnThisApplication.flatMap((applicant) => applicant.Pets || []);

  const handleBuildAnimalsData = (thisPet: ApplicantPetV2Dto | undefined) => {
    const animalsData: ApplicantEntityDataTableField[] = [
      {
        label: 'Species',
        value: thisPet?.Species || '',
      },
      {
        label: 'Breed',
        value: thisPet?.Breed || '',
      },
      {
        label: 'Name',
        value: thisPet?.Name || '',
      },
      {
        label: 'Weight',
        value: thisPet?.WeightLbs ? `${String(thisPet?.WeightLbs)} lbs` : '',
      },
      {
        label : 'Are they indoors?',
        value: thisPet?.LivesOnPremises ? 'Yes' : "No"
      }
    ];

    const customQuestionsForPersonalInfo: ApplicantEntityDataTableField[] = handleBuildCustomQuestionDataTable(thisPet?.CustomQuestionsAnswers || []);

    return [...animalsData, ...(customQuestionsForPersonalInfo || [])];
  };

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'auto',
        padding: 2,
        height: 'calc( 100vh - 294px )',
        '&::-webkit-scrollbar': {
          width: 7,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
          borderRadius: '24px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'darkgrey',
          borderRadius: '24px',
        },
      }}
    >
      <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 'bold', marginBottom: 1 }}>Animals:</Typography>
      <Divider sx={{ marginY: 1, borderBottomWidth: 1, backgroundColor: 'black' }} />

      {allAnimalsOnThisApplication?.length ? (
        allAnimalsOnThisApplication?.map((animal) => {
          const belongsToOccupant = allApplicantsOnThisApplication.find((app) => app.Uuid === animal.BelongsToOccupantUuid);
          return (
            <Accordion sx={{ marginTop: 2 }} elevation={0} key={animal.Uuid}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ marginTop: 2, boxShadow: 'none', '& .MuiPaper-root': { boxShadow: 'none' } }}>
                <Grid container sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Grid item xs={4}>
                    <Typography sx={{ fontFamily: 'Work Sans !important' }}>{animal.Species || ''}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontFamily: 'Work Sans !important' }}>{animal.Breed || ''}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontFamily: 'Work Sans !important' }}>{(belongsToOccupant?.FirstName || '') + ' ' + (belongsToOccupant?.LastName || '')}</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <ApplicationDetailsApplicantEntityData tableData={handleBuildAnimalsData(animal)} attachments={animal.Attachments || []} />
              </AccordionDetails>
            </Accordion>
          );
        })
      ) : (
        <Grid container sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 2 }}>
          <Grid item xs={12}>
            <Typography sx={{ fontFamily: 'Work Sans !important' }}>Applicants have indicated there are no Animals.</Typography>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
